<div class="dialog-header verify-user mb-3" *ngIf="data.type == 51">
  <h2 mat-dialog-title class="text-center h3">{{ data.title }}</h2>
  <div mat-dialog-content class="p-3">
    <div style="display: flex; justify-content: space-around;">
      <label>
        <input type="radio" style="position: static;" name="cropSelection" [(ngModel)]="cropSelection" [value]=1 (ngModelChange)="updateCropper()">
        Round
      </label>
      <label>
        <input type="radio" style="position: static;" name="cropSelection" [(ngModel)]="cropSelection" [value]=2 (ngModelChange)="updateCropper()">
        Square
      </label>
      <label>
        <input type="radio" style="position: static;" name="cropSelection" [(ngModel)]="cropSelection" [value]=3 (ngModelChange)="updateCropper()">
        Rectangle
      </label>
    </div>

    <image-cropper style="max-height: 300px" class="border new_div_change" [imageFile]="data.image" [maintainAspectRatio]="true" [aspectRatio]="ratio" [cropperMinHeight]="100" [containWithinAspectRatio]="false" [roundCropper]="cropSelection == 1" [cropperMinWidth]="100" [format]="'png'" (imageCropped)="imageCropped_fun($event)" *ngIf="data.image && showCropper">
  </image-cropper>
  
  </div>
  <div class="d-flex justify-content-between" mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close (click)="dialogRef.close('0')" style="height: 48px;">
      Cancel
    </button>
    <button mat-raised-button (click)="acceptImage()">Confirm</button>
  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 52"
  style="max-height: 80vh !important; overflow: auto; max-width: 610px;">
  <h2 mat-dialog-title class="h3  p-0 pt-4 px-3 mb-0 pb-3" style="left: 11px; width: fit-content;">{{ data.title }}</h2>
  <div mat-dialog-content class="p-3" *ngIf="data.disabled == false">
    <div class="form-group col-12 col-md-12">
      <div class="custom-form flex-grow-1 me-md-3">
        <input class="input_field px-3 pt-3" [(ngModel)]="alternateEmail" required trim 
          [readonly]="data?.disabled || false" />
        <label for="text" class="label-name">
          <span class="content-name f-c-p-3">
            Email
          </span>
        </label>
      </div>
    </div>
  </div>
  <div class="p-3 ps-2 ms-2" *ngIf="data.disabled == true">
    <strong>
      <h6>Are you sure you want to delete this alternate email ?</h6>
    </strong>
  </div>
  <div class="ms-2 pt-0 pb-4" mat-dialog-actions>
    <button mat-raised-button class="btn-save py-0" (click)="AddAlternateEmail()">
      Accept
    </button>
    <button mat-stroked-button mat-dialog-close (click)="dialogRef.close('0')">
      Cancel
    </button>
  </div>
</div>

<!--  Modal Account Information -->
<div class="dialog-header" *ngIf="data.type == 55" [formGroup]="bankDetails_form"
  style="max-height: 80vh !important; overflow: auto; max-width: 750px;">
  <div class="px-1 head_top w-100" style="position: sticky; top:0;z-index: 10;">
    <h4 class="px-4 py-4">
      {{ data.title
      }}<mat-icon (click)="dialogRef.close()" class="close pull-right pointer_1">close</mat-icon>
    </h4>
  </div>
  <div class="row g-0 p-3">
    <div class="col-12 px-3 py-2">
      <h3>Personal Info</h3>
    </div>
    <div class="col-12 col-md-6">
      <div class="form-group col-12 col-md-12">
        <label class="form-label d-block">
          First Name <mat-icon
            [ngClass]="[bankDetails.stripe_data.individual_first_name_verified == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
            {{bankDetails.stripe_data.individual_first_name_verified == 1 ? 'check_circle' : 'highlight_off'}}
          </mat-icon></label>
        <input class="form-input w-100 d-block" placeholder="First Name" formControlName="doctor_first_name"
          [disabled]="bankDetails.stripe_data.individual_first_name_verified == 1" trim  required />
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group col-12 col-md-12">
        <label class="form-label d-block">
          Last Name <mat-icon
            [ngClass]="[bankDetails.stripe_data.individual_last_name_verified == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
            {{bankDetails.stripe_data.individual_last_name_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
        </label>
        <input class="form-input w-100 d-block" placeholder="Last Name" formControlName="doctor_last_name"
          [disabled]="bankDetails.stripe_data.individual_last_name_verified == 1" trim  required />
      </div>
    </div>

    <!-- Date Of Birth -->
    <div class="col-12 col-md-6" *ngIf=" bankDetails.stripe_data.account_type == 'individual'">
      <div appearance="outline" class="col-12 abc w-100 disabled form-group">
        <label class="form-label d-block mb-md-1">DOB <mat-icon
            [ngClass]="[bankDetails.stripe_data.dob_verified == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
            {{bankDetails.stripe_data.dob_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon></label>
        <mat-form-field style="max-height: 56px;" aria-autocomplete="none" appearance="outline" class="w-100 " readonly
          *ngIf="bankDetails.stripe_data.dob_verified == 0">
          <!--  -->
          <input name="DOB" matInput [matDatepicker]="picker" formControlName="date_of_birth"
            [disabled]="bankDetails.stripe_data.dob_verified == 1" readonly />
          <mat-datepicker-toggle class="py-2" matSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker #picker [disabled]="bankDetails.stripe_data.dob_verified == 1"></mat-datepicker>
        </mat-form-field>
        <!-- date of birth change -->
        <input class="form-input w-100 d-block" placeholder="Date Of Birth" formControlName="date_of_birth"
          *ngIf="bankDetails.stripe_data.dob_verified == 1" [disabled]="bankDetails.stripe_data.dob_verified == 1"
          trim  required />
      </div>
    </div>
    <!-- Date Of Birth -->

    <!-- dob close -->
    <div class="col-12 col-md-6" *ngIf=" bankDetails.stripe_data.account_type == 'individual'">
      <div class="form-group col-12 col-md-12">
        <label class="form-label d-block">
          Social Security Number <mat-icon
            [ngClass]="[bankDetails.stripe_data.ssn_verified == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
            {{bankDetails.stripe_data.ssn_verified == 1 ? 'check_circle' : 'highlight_off'}}
          </mat-icon></label>
        <input class="form-input w-100 d-block" placeholder="Social Security Number (SSN)" formControlName="tin"
          [disabled]="bankDetails.stripe_data.ssn_verified == 1" trim  required />
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group col-12 col-md-12">
        <label class="form-label d-block">
          Address <mat-icon
            [ngClass]="[bankDetails.stripe_data.individual_address_verified == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
            {{ bankDetails.stripe_data.individual_address_verified == 1 ? 'check_circle' : 'highlight_off'}}
          </mat-icon></label>
        <input class="form-input w-100 d-block" placeholder="Address" formControlName="address"
          [disabled]="bankDetails.stripe_data.individual_address_verified == 1" trim  required />
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="col-12 form-group">
        <label class="form-label d-block">
          zipCode <mat-icon
            [ngClass]="[bankDetails.stripe_data.individual_address_verified == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
            {{bankDetails.stripe_data.individual_address_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
        </label>
        <input class="form-input w-100 d-block" placeholder="zipCode" formControlName="zip"
          [disabled]="bankDetails.stripe_data.individual_address_verified == 1" trim  required />
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group col-12 col-md-12">
        <label class="form-label d-block">
          State <mat-icon
            [ngClass]="[bankDetails.stripe_data.individual_address_verified == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
            {{bankDetails.stripe_data.individual_address_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
        </label>
        <input class="form-input w-100 d-block" placeholder="State" readonly formControlName="State" disabled
          trim  required />
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group col-12 col-md-12">
        <label class="form-label d-block">
          City <mat-icon
            [ngClass]="[bankDetails.stripe_data.individual_address_verified == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
            {{bankDetails.stripe_data.individual_address_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
        </label>
        <input class="form-input w-100 d-block" placeholder="City" formControlName="city" readonly disabled trim 
          required />
      </div>
    </div>

    <div class="col-md-12"
      *ngIf="bankDetails.stripe_data.individual_document_verified == 0 && bankDetails.stripe_data.account_type == 'individual' ">
      <div class="col-md-12">Requirements for ID verification
        <mat-icon
          [ngClass]="[bankDetails.stripe_data.individual_document_verified  == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
          {{bankDetails.stripe_data.individual_document_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
      </div>
      <div class="col-12">
        <ul>
          <li>
            <small>
              Acceptable documents vary by country, although a passport scan is
              always acceptable and preferred.
            </small>
          </li>
          <li>
            <small>
              Scans of both the front and back are usually required for
              government-issued IDs and driver’s licenses.
            </small>
          </li>
          <li>
            <small>
              Files need to be JPEGs or PNGs smaller than 5MB. We can’t verify
              PDFs.
            </small>
          </li>
          <li>
            <small>
              Files should be in color, be rotated with the image right-side up,
              and have all information clearly legible.
            </small>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-md-12" *ngIf=" bankDetails.stripe_data.account_type == 'individual' ">
      <div class="col-md-12"
        *ngIf="bankDetails.stripe_data.individual_document_verified == 1 && bankDetails.stripe_data.account_type == 'individual' ">
        Identity Document: <mat-icon
          [ngClass]="[bankDetails.stripe_data.individual_document_verified  == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
          {{bankDetails.stripe_data.individual_document_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
      </div>
      <div class="col-md-12 d-flex align-item-center py-4 px-3">
        <div class="col-md-6 ">
          <div>Photo ID-Front</div>
          <label for="my-file_1" class="input-file-trigger input_lable"
            *ngIf="bankDetails.stripe_data.individual_document_verified == 0">
            <div class="input-file-container">
              <input accept="image/*" class="input-file d-none" (change)="uploadPhotoId($event, 'F')" id="my-file_1"
                type="file" />
              <label tabindex="0" for="my-file_1" class="input-file-trigger input_lable">Upload File.</label>
            </div>
          </label>
          <div class="col-md-12 text-left text-primary-custom px-0"
            *ngIf="bankDetails.stripe_data.individual_document_verified == 0">
            <p class="file-return">
              {{ PhotoIdEvidence?.photoF?.name || "file not selected" }}
            </p>
          </div>
          <strong *ngIf="bankDetails.stripe_data.individual_document_verified == 1"
            style="color: rgb(93, 156, 236); flex: 0.5">Provided</strong>
        </div>

        <div class="col-md-6 " *ngIf="
            bankDetails.stripe_data.back_document_provided == 1 ||
            bankDetails.stripe_data.individual_document_verified == 0
          ">
          <div>Photo ID-Back</div>
          <label for="my-file1"
            [ngClass]="[PhotoIdEvidence?.photoF?.name == '' ? 'input-file-trigger input_lable':'isdisabled']"
            *ngIf="bankDetails.stripe_data.individual_document_verified == 0">
            <div class="input-file-container">
              <input [disabled]="!PhotoIdEvidence?.photoF?.name" class="input-file d-none" accept="image/*"
                (change)="uploadPhotoId($event, 'B')" id="my-file1" type="file" />
              <label tabindex="0" for="my-file1"
                [ngClass]="[PhotoIdEvidence?.photoF?.name == '' ? 'isdisabled':'input-file-trigger input_lable']">Upload
                File.</label>
            </div>
          </label>
          <div class="col-md-12 text-left text-primary-custom px-0"
            *ngIf="bankDetails.stripe_data.individual_document_verified == 0">
            <p class="file-return">
              {{ PhotoIdEvidence?.photoB?.name || "file not selected" }}
            </p>
          </div>
          <strong *ngIf="bankDetails.stripe_data.individual_document_verified == 1"
            style="color: rgb(93, 156, 236); flex: 0.5">Provided</strong>
        </div>
      </div>
    </div>
    <hr />
    <!-- company info -->
    <div class="row" *ngIf="bankDetails.stripe_data.account_type !== 'individual' ">
      <div class="col-12 px-3 py-2">
        <h3 class="px-3">Company Information</h3>
      </div>
      <div class="col-12 col-md-6 pe-0">
        <div class="form-group col-12 col-md-12">
          <label class="form-label d-block">
            Business Name <mat-icon
              [ngClass]="[bankDetails.stripe_data.company_name_verified  == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
              {{bankDetails.stripe_data.company_name_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
          </label>
          <input class="form-input w-100 d-block" placeholder="Business Name" formControlName="business_name"
            [disabled]="bankDetails.stripe_data?.company_name_verified" trim  required />
        </div>
      </div>

      <div class="col-12 col-md-6 ps-0">
        <div class="form-group col-12 col-md-12">
          <label class="form-label d-block">
            Business Tax Id <mat-icon
              [ngClass]="[bankDetails.stripe_data.company_tax_id_verified  == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
              {{bankDetails.stripe_data.company_tax_id_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
          </label>
          <input class="form-input w-100 d-block" placeholder="**********" formControlName="business_tax_id"
            [disabled]="bankDetails.stripe_data?.company_tax_id_verified" trim  required />
        </div>
      </div>

      <ng-container formGroupName="address_business">
        <div class="col-12 col-md-6 pe-0">
          <div class="form-group col-12 col-md-12">
            <label class="form-label d-block">
              Business Address <mat-icon
                [ngClass]="[bankDetails.stripe_data.company_address_verified  == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
                {{ bankDetails.stripe_data.company_address_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
            </label>
            <input class="form-input w-100 d-block" formControlName="line1"
              [disabled]="bankDetails.stripe_data?.company_address_verified == 1" trim  required />
          </div>
        </div>

        <div class="col-12 col-md-6 ps-0">
          <div class="form-group col-12 col-md-12">
            <label class="form-label d-block" *ngIf="bankDetails.stripe_data?.company_address?.post_code !== ''">
              ZipCode <mat-icon
                [ngClass]="[bankDetails.stripe_data.company_address_verified  == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
                {{ bankDetails.stripe_data.company_address_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
            </label>
            <zip-selector [placeholder]="" *ngIf="bankDetails.stripe_data?.company_address?.post_code == ''"
              [isRequired]="true" id="zipPostalCode" name="zipPostalCode" [model]="zip_company" ngDefaultControl>
            </zip-selector>
            <input class="form-input w-100 d-block" formControlName="postal_code"
              [disabled]="bankDetails.stripe_data?.company_address_verified == 1" trim  required />
          </div>
        </div>

        <div class="col-12 col-md-6 pe-0">
          <div class="form-group col-12 col-md-12">
            <label class="form-label d-block">
              State <mat-icon
                [ngClass]="[bankDetails.stripe_data.company_address_verified == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
                {{ bankDetails.stripe_data.company_address_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
            </label>
            <input class="form-input w-100 d-block" formControlName="state"
              [disabled]="bankDetails.stripe_data?.company_address_verified == 1" trim  required />
          </div>
        </div>

        <div class="col-12 col-md-6 ps-0">
          <div class="form-group col-12 col-md-12">
            <label class="form-label d-block">
              City <mat-icon
                [ngClass]="[bankDetails.stripe_data.company_address_verified  == 1 ? 'mat-check text-success-custom' : 'mat-check text-danger-custom']">
                {{ bankDetails.stripe_data.company_address_verified == 1 ? 'check_circle' : 'highlight_off'}}</mat-icon>
            </label>
            <input class="form-input w-100 d-block" formControlName="city"
              [disabled]="bankDetails.stripe_data?.company_address_verified == 1" trim  required />
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-12 px-3 py-2">
      <button class="px-4 w-25" style="max-height:40px" mat-raised-button (click)="uploadImages()">
        Save
      </button>
    </div>
  </div>
</div>